const config = {
  REGION: "ap-southeast-2",
  BUCKET: "pg-prod-file-gateway",
  USER_POOL_ID: "ap-southeast-2_5GCuiTjLz",
  USER_POOL_APP_CLIENT_ID: "7i72h527i5iu63higo9ghgfvdq",
  USER_POOL_DOMAIN: "https://secure-prod-idp-filegateway-pg.auth.ap-southeast-2.amazoncognito.com",
  IDENTITY_POOL_ID: "ap-southeast-2:c1b99fbe-5b33-486e-a91a-d77c21474eea",
};

export default config;
